import React from 'react'

const UserAgreementPage: React.FC = () => {
    return (
        <div className="flex flex-row w-[1200px] h-full bg-[#e4e7ea] p-10 rounded-3xl gap-2 ">
            <div className="flex flex-col w-full h-full items-start justify-start text-[#000000] gap-14 text-[16px]">
                <div className="flex flex-row w-full items-center justify-end font-semibold">
                    Редакция от 13.01.2025 г.
                </div>
                <div className="flex flex-row w-full items-center justify-center font-semibold">
                    Пользовательское соглашение
                </div>
                <div className="flex flex-row w-full items-center justify-center text-justify">
                    Настоящее пользовательское соглашение (далее — Соглашение)
                    определяет порядок и условия использования материалов и
                    сервисов, размещённых в сети Интернет по адресу
                    https://noxsys.ru/#/docs/user-agreement (далее — Сайт)
                    Пользователями (как этот термин определён ниже) данного
                    Пользователями Сайта означает, что они безоговорочно
                    принимают и обязуются соблюдать все условия настоящего
                    Соглашения.
                </div>
                <div className="flex flex-col w-full items-start justify-start">
                    <div className="flex flex-row w-full items-center justify-center font-semibold">
                        1. ОБЩИЕ ПОЛОЖЕНИЯ
                    </div>
                    <div className="flex flex-col w-full items-start justify-stretch indent-7 text-justify">
                        <p>
                            1.1. В настоящем Соглашении, если из текста
                            Соглашения прямо не вытекает иное, следующие
                            указываемые в письменной форме с заглавной буквы
                            слова и выражения, используемые при взаимодействии
                            сторон в ходе исполнения обязательств, будут иметь
                            указанные ниже значения:
                        </p>
                        <p>
                            {' '}
                            Администратор — Обществом с ограниченной
                            ответственностью «Технологии Закупок» (ОГРН
                            1211400010491, 677000, Российская Федерация,
                            Республика Саха (Якутия), г. Якутск, пр. Ленина, 1,
                            офис 625), которому принадлежат все соответствующие
                            права на Сайт.
                        </p>
                        <p>
                            {' '}
                            Акцепт — полное и безоговорочное принятие условий
                            настоящего Соглашения, размещённого на Сайте по
                            адресу https://noxsys.ru/#/docs/user-agreement,
                            осуществляемое путём совершения Пользователем любых
                            действий по использованию Сайта.
                        </p>
                        <p>
                            {' '}
                            Аутентификационные данные Пользователя — логин
                            (адрес электронной почты Пользователя) и пароль (код
                            доступа, который Пользователь указал в качестве
                            пароля), которые в совокупности признаются простой
                            электронной подписью Пользователя. Пользователь
                            самостоятельно обеспечивает сохранность своих
                            Аутентификационных данных, а также возможность
                            получения направляемых ему ссылок для восстановления
                            пароля;
                        </p>
                        <p>
                            {' '}
                            Пользователь — лицо, осуществляющее доступ к Сайту и
                            использующее материалы и сервисы, размещённые на
                            Сайте.
                        </p>
                        <p>
                            {' '}
                            Контент — любое информационно значимое наполнение
                            Сайта, включая, но не ограничиваясь, фото, аудио,
                            видео, текст и иные медиаматериалы.
                        </p>
                        <p>
                            {' '}
                            Личный кабинет — персонализированная часть Сайта,
                            посредством которой обеспечивается обмен информацией
                            и документацией в электронном виде между
                            Пользователем и Сайтом. Доступ к Личному кабинету
                            осуществляется путём ввода Пользователем
                            Аутентификационных данных.
                        </p>
                        <p>
                            {' '}
                            Персональные данные — любая информация, относящаяся
                            к определённому или определяемому на основании такой
                            информации физическому лицу (субъекту персональных
                            данных), в том числе его фамилия, имя, отчество,
                            год, месяц, день рождения).
                        </p>
                        <p>
                            {' '}
                            Обработка персональных данных — любое действие
                            (операция) или совокупность действий (операций),
                            совершаемых с использованием средств автоматизации
                            или без использования таких средств с персональными
                            данными, включая сбор, запись, систематизацию,
                            накопление, хранение, уточнение (обновление,
                            изменение), извлечение, использование, передачу
                            (распространение, предоставление, доступ),
                            обезличивание, блокирование, удаление, уничтожение
                            персональных данных.
                        </p>
                        <p>
                            {' '}
                            Сайт — ресурс в сети Интернет, представляющий собой
                            совокупность содержащихся в информационной системе
                            информации и объектов интеллектуальной собственности
                            (в том числе программа для ЭВМ, база данных,
                            графическое оформление интерфейса (дизайн) и др.),
                            доступ к которому обеспечивается с различных
                            пользовательских устройств, подключённых к сети
                            Интернет, посредством специального программного
                            обеспечения для просмотра веб-страниц (браузер) по
                            сетевому адресу https://noxsys.ru (и адресам
                            подразделов Сайта).
                        </p>
                        <p>
                            {' '}
                            1.2. Все остальные термины и определения,
                            встречающиеся в тексте Соглашения, толкуются в
                            соответствии с действующим законодательством
                            Российской Федерации.
                        </p>
                    </div>
                </div>
                <div className="flex flex-col w-full items-start justify-start">
                    <div className="flex flex-row w-full items-center justify-center font-semibold">
                        2. ПРЕДМЕТ СОГЛАШЕНИЯ
                    </div>
                    <div className="flex flex-col w-full items-start justify-stretch indent-7 text-justify">
                        <p>
                            {' '}
                            2.1. В соответствии с настоящим Соглашением
                            Администратор предоставляет любому Пользователю
                            право безвозмездного использования Сайта любым
                            способом и в любой форме в пределах его объявленных
                            функциональных возможностей и на условиях,
                            изложенных в настоящем Соглашении.
                        </p>
                        <p>
                            {' '}
                            2.2. Использование Сайта осуществляется в
                            соответствии с принятым в мировой
                            правоприменительной практике принципом «как есть»
                            (as is). В соответствии с данным принципом никакие
                            гарантии, что Сайт будет соответствовать всем
                            требованиям Пользователя, работать непрерывно,
                            быстро и без ошибок; результаты, которые могут быть
                            получены с использованием Сайта, будут точными и
                            надёжными не прилагаются и не предусматриваются.
                        </p>
                        <p>
                            {' '}
                            2.3. Пользователь считается присоединившимся к
                            настоящему Соглашению в соответствии с положениями
                            статьи 438 ГК РФ, получая доступ к материалам и
                            сервисам Сайта и осуществляя использование Сайта
                            любым способом и в любой форме в пределах его
                            функциональных возможностей, включая:
                        </p>
                        <p>
                            {' '}
                            2.3.1. просмотр материалов, размещённых на Сайте;
                        </p>
                        <p> 2.3.2. использование сервисов Сайта;</p>
                        <p> 2.3.3. регистрация в Личном кабинете;</p>
                        <p>
                            {' '}
                            2.3.4. направление любых сообщений с использованием
                            онлайн-форм на Сайте;
                        </p>
                        <p> 2.3.5. иное использование Сайта.</p>
                        <p>
                            {' '}
                            2.4. Используя Сайт в порядке, предусмотренном п.
                            2.3 Соглашения, Пользователь подтверждает, что:
                        </p>
                        <p>
                            {' '}
                            2.4.1. ознакомился с условиями настоящего Соглашения
                            в полном объёме до начала использования Сайта;
                        </p>
                        <p>
                            {' '}
                            2.4.2. безоговорочно принимает все условия
                            настоящего Соглашения в полном объёме без каких-либо
                            изъятий и ограничений, а также обязуется соблюдать
                            их или прекратить использование Сайта в случае
                            несогласия с условиями настоящего Соглашения.
                        </p>
                        <p>
                            {' '}
                            2.5. Никакое из положений Соглашения не может
                            трактоваться как установление между Администратором
                            и Пользователем агентских отношений, отношений по
                            ведению совместной деятельности или каких-либо иных
                            правоотношений, прямо не предусмотренных настоящим
                            Соглашением.
                        </p>
                        <p>
                            {' '}
                            2.6. Все возможные споры, вытекающие из настоящего
                            Соглашения или связанные с ним, подлежат разрешению
                            в соответствии с действующим законодательством
                            Российской Федерации.
                        </p>
                        <p>
                            {' '}
                            2.7. Порядок исполнения обязательств, возникающих в
                            соответствии с иными договорами, заключаемыми между
                            Пользователем и Администратором, устанавливается в
                            таких договорах.
                        </p>
                    </div>
                </div>
                <div className="flex flex-col w-full items-start justify-start">
                    <div className="flex flex-row w-full items-center justify-center font-semibold">
                        3. РЕГИСТРАЦИЯ
                    </div>
                    <div className="flex flex-col w-full items-start justify-stretch indent-7 text-justify">
                        <p>
                            3.1. Для использования отдельного функционала Сайта
                            Пользователю необходимо пройти процедуру
                            регистрации, в результате которой ему будет
                            предоставлен персональный доступ в Личный кабинет.
                        </p>
                        <p>
                            3.2. В процессе регистрации Пользователь обязуется
                            достоверно и полно заполнить информацию о себе по
                            вопросам, предлагаемым в форме регистрации, и
                            поддерживать эту информацию в актуальном состоянии.
                            Если Пользователь предоставил неверную информацию
                            или у Администратора есть основания полагать, что
                            предоставленная Пользователем информация неполна или
                            недостоверна, Администратор имеет право по своему
                            усмотрению заблокировать доступ в Личный кабинет
                            либо удалить учётную запись Пользователя и отказать
                            Пользователю в использовании отдельного функционала
                            Сайта.
                        </p>
                        <p>
                            3.3. Администратор вправе потребовать от
                            Пользователя подтверждения данных, указанных при
                            регистрации, и запросить в связи с этим
                            подтверждающие документы. В случае если данные
                            Пользователя, указанные в предоставленных им
                            документах, не соответствуют данным, указанным при
                            регистрации, а также в случае, когда данные,
                            указанные при регистрации, не позволяют
                            идентифицировать Пользователя, Администратор вправе
                            отказать Пользователю в доступе в Личный кабинет и
                            использовании Сайта.
                        </p>
                        <p>
                            3.4. Пользователь подтверждает и гарантирует, что
                            все действия, предусмотренные для Пользователя
                            настоящим Соглашением, совершаются лицом, чьи данные
                            направлены Администратору при прохождении процедуры
                            регистрации.
                        </p>
                        <p>
                            3.5. Пользователь самостоятельно несёт
                            ответственность за безопасность и сохранность своих
                            Аутентификационных данных. Пользователь
                            самостоятельно несёт ответственность за все действия
                            (а также их последствия) при использовании Сайта под
                            Аутентификационными данными Пользователя, такие
                            действия считаются произведёнными самим
                            Пользователем.
                        </p>
                        <p>
                            3.6. Пользователь обязан немедленно уведомить
                            Администратора о любом случае несанкционированного
                            доступа к Личному кабинету Пользователя и (или) о
                            любом нарушении (подозрениях о нарушении)
                            конфиденциальности своего пароля.
                        </p>
                        <p>
                            3.7. Пользователь не вправе воспроизводить,
                            повторять и копировать, продавать и перепродавать, а
                            также использовать для каких-либо коммерческих целей
                            Сайт, его Контент или доступ к нему, кроме тех
                            случаев, когда Пользователь получил такое разрешение
                            от Администратора либо когда это прямо предусмотрено
                            настоящим Соглашением.
                        </p>
                        <p>
                            3.8. При регистрации на Сайте Пользователь даёт
                            согласие на получение от Администратора рассылок,
                            пуш-уведомлений, и иных уведомлений
                            рекламно-информационного характера. Настройка
                            параметров рассылки (периодичность получения,
                            возможность и способы отказа от рассылки и пр.)
                            будет возможна для Пользователя непосредственно
                            через сообщения на электронную почту Администратора
                            или по телефону. Рассылки поступают в виде
                            электронного письма на адрес, звонка и (или)
                            короткого сообщения (пуш или аналог) на номер
                            телефона, указанный Пользователем при регистрации.
                        </p>
                    </div>
                </div>
                <div className="flex flex-col w-full items-start justify-start">
                    <div className="flex flex-row w-full items-center justify-center font-semibold">
                        4. ПРАВА И ОБЯЗАННОСТИ АДМИНИСТРАТОРА
                    </div>
                    <div className="flex flex-col w-full items-start justify-stretch indent-7 text-justify">
                        <p>
                            4.1. В целях повышения качества Сайта Администратор
                            или действующие по его поручению лица вправе
                            осуществлять сбор мнений и отзывов Пользователей по
                            различным вопросам путём направления информационных
                            сообщений при очередном посещении Пользователем
                            Сайта либо осуществления связи по контактным данным,
                            указанным Пользователем при регистрации Личного
                            кабинета, посредством телефонных звонков или
                            электронных писем. Собранные мнения и отзывы могут
                            быть использованы для формирования статистических
                            данных, которые могут быть использованы в сервисах,
                            реализуемых на Сайте. Отзывы, предоставленные
                            Пользователем при проведении опроса, также могут
                            быть опубликованы (или обнародованы иным способом)
                            Администратором.
                        </p>
                        <p>
                            4.2. Администратор вправе направлять на адрес
                            электронной почты и (или) абонентский номер
                            Пользователя информационные сообщения, в том числе,
                            но не ограничиваясь, сообщения, связанные с
                            функционированием Сайта, уведомления, связанные с
                            исполнением договоров, заключённых с Пользователем,
                            информацию о восстановлении пароля и т. д.
                            Подтверждением согласия Пользователя на получение от
                            Администратора указанных в настоящем пункте
                            информационных сообщений является принятие условий
                            Соглашения.
                        </p>
                        <p>
                            4.3. Администратор оставляет за собой право
                            заблокировать Личный кабинет Пользователя в
                            соответствии с условиями Соглашения либо в случае
                            нарушения Пользователем условий настоящего
                            Соглашения.
                        </p>
                        <p>
                            4.4. Сайт или его сервисы могут быть в то или иное
                            время частично или полностью недоступны по причине
                            проведения профилактических или иных работ или по
                            любым другим причинам технического характера.
                            Администратор вправе производить модификацию любого
                            программного обеспечения Сайта, проводить
                            необходимые профилактические или иные работы,
                            приостанавливать работу Сайта в то или иное время по
                            личному усмотрению с предварительным уведомлением
                            Пользователя или без такового.
                        </p>
                        <p>
                            4.5. Администратор не несёт ответственности за любые
                            ошибки, упущения, прерывания, удаление, дефекты,
                            задержку в обработке или передаче данных, сбое линий
                            связи, кражу, уничтожение или неправомерный доступ к
                            информации Пользователя, размещённой на Сайте или в
                            любом другом месте. Администратор не отвечает за
                            любые технические сбои или иные проблемы любых
                            телефонных сетей или служб, компьютерных систем,
                            серверов или провайдеров, компьютерного или
                            телефонного оборудования, программного обеспечения,
                            сбоев сервисов электронной почты или скриптов по
                            техническим причинам.
                        </p>
                        <p>
                            4.6. В течение срока действия настоящего Соглашения
                            Администратор предпримет все усилия для устранения
                            каких-либо технических сбоев и ошибок в случае их
                            возникновения в разумный срок. При этом
                            Администратор не гарантирует полного отсутствия
                            технических ошибок и сбоев по причинам, вызванным
                            неисправностью оборудования, некорректной работой
                            программного обеспечения либо программной среды.
                        </p>
                        <p>
                            4.7. Пользователю не предоставляется никаких
                            интеллектуальных прав, за исключением прямо
                            предусмотренных настоящим Соглашением, в отношении
                            как Сайта в целом, так и в отношении отдельного
                            программного обеспечения, дизайнерских решений,
                            литературных, графических и аудиовизуальных
                            произведений, входящих в состав Сайта.
                        </p>
                    </div>
                </div>
                <div className="flex flex-col w-full items-start justify-start">
                    <div className="flex flex-row w-full items-center justify-center font-semibold">
                        5. ПРАВА И ОБЯЗАННОСТИ ПОЛЬЗОВАТЕЛЯ
                    </div>
                    <div className="flex flex-col w-full items-start justify-stretch indent-7 text-justify">
                        <p>
                            5.1. Пользователь обязуется знакомиться с актуальной
                            версией Соглашения при каждом посещении Сайта до
                            начала использования функционала Сайта и соблюдать
                            его условия.
                        </p>
                        <p>
                            5.2. Пользователь обязуется предоставлять
                            достоверную и полную информацию при использовании
                            Сайта.
                        </p>
                        <p>
                            5.3. Пользователь соглашается не предпринимать
                            действий и не оставлять комментарии и записи,
                            которые могут рассматриваться как нарушающие
                            российское законодательство или нормы международного
                            права, в том числе в сфере интеллектуальной
                            собственности, авторских и (или) смежных прав,
                            общепринятые нормы морали и нравственности, а также
                            любых действий, которые приводят или могут привести
                            к нарушению нормальной работы Сайта.
                        </p>
                        <p>
                            5.4. Использование материалов Сайта без согласия
                            правообладателей не допускается.
                        </p>
                        <p>
                            5.5. При цитировании материалов Сайта, включая
                            охраняемые авторские произведения, ссылка на Сайт
                            обязательна.
                        </p>
                        <p>
                            5.6. Пользователь обязуется нести ответственность за
                            все действия, совершённые при использовании его
                            Личного кабинета, а также за последствия, вызванные
                            такими действиями.
                        </p>
                        <p>
                            5.7. При использовании Сайта Пользователь не вправе
                            нарушать права и законные интересы третьих лиц, а
                            также причинять вред в какой-либо форме, включая
                            вред деловой репутации.
                        </p>
                        <p>
                            5.8. Пользователь не вправе нарушать нормальную
                            работу как отдельных сервисов Сайта, так и Сайта в
                            целом.
                        </p>
                        <p>
                            5.9. Пользователь обязан самостоятельно отслеживать
                            внесение изменений в настоящее Соглашение.
                        </p>
                        <p>
                            5.10. Пользователь вправе прекратить доступ к
                            Личному кабинету путём направления соответствующего
                            уведомления Администратору.
                        </p>
                    </div>
                </div>
                <div className="flex flex-col w-full items-start justify-start">
                    <div className="flex flex-row w-full items-center justify-center font-semibold">
                        6. ОГРАНИЧЕНИЕ ОТВЕТСТВЕННОСТИ АДМИНИСТРАТОРА
                    </div>
                    <div className="flex flex-col w-full items-start justify-stretch indent-7 text-justify">
                        <p>
                            6.1. Администратор гарантирует достоверность,
                            точность, полноту или качество только той
                            информации, которую он сам непосредственно разместил
                            на Сайте. Администратор не несёт ответственности за
                            достоверность, точность, полноту и качество
                            информации, размещённой на Сайте третьими лицами, в
                            том числе Пользователями.
                        </p>
                        <p>
                            6.2. Администратор не несёт ответственности за
                            некорректное поведение лиц, использующих Сайт.
                        </p>
                        <p>6.3. Администратор не гарантирует, что:</p>
                        <p>
                            6.3.1. Сайт будет соответствовать требованиям
                            Пользователя;
                        </p>
                        <p>
                            6.3.2. качество какого-либо продукта, услуг,
                            информации, полученных с использованием Сайта, будет
                            соответствовать ожиданиям Пользователя;
                        </p>
                        <p>
                            6.3.3. Сайт будет работать непрерывно, быстро,
                            надёжно и без ошибок и будет соответствовать
                            ожиданиям Пользователя;
                        </p>
                        <p>6.3.4. все ошибки на Сайте будут исправлены.</p>
                        <p>
                            6.4. Администратор не несёт ответственности и не
                            имеет прямых или косвенных обязательств перед
                            Пользователем в связи с любыми возможными или
                            возникшими потерями или убытками, связанными с любым
                            содержанием Сайта, регистрацией авторских прав и
                            сведениями о такой регистрации, товарами или
                            услугами, доступными или полученными через внешние
                            сайты или ресурсы либо иные контакты Пользователя, в
                            которые он вступил, используя размещённую на Сайте
                            информацию или ссылки на внешние ресурсы.
                        </p>
                        <p>
                            6.5. Администратор не несёт ответственности за
                            полноту и достоверность сведений, предоставляемых
                            Пользователями при осуществлении регистрационных
                            действий на Сайте, а также не отвечает за возможный
                            ущерб, связанный с недостоверностью или неполнотой
                            таких сведений. Администратор не принимает на себя
                            никаких обязательств по проверке достоверности
                            Персональных данных, указанных Пользователем, и не
                            несёт ответственности в случае, если Пользователь
                            предоставит больший объём данных, чем это
                            предусмотрено соответствующими формами на Сайте.
                        </p>
                        <p>
                            6.6. Администратор не несёт ответственности перед
                            Пользователем или любыми другими третьими лицами и
                            не возмещает любой ущерб, включая упущенную выгоду
                            или потерянные данные, вред, причинённый чести,
                            достоинству или деловой репутации, и иные убытки,
                            причинённые в связи с использованием Сайта или иных
                            материалов и сервисов, содержащихся на Сайте, за
                            исключением случаев, прямо предусмотренных
                            Соглашением.
                        </p>
                        <p>
                            6.7. Администратор исходит из того, что все формы на
                            Сайте заполняет непосредственно Пользователь.
                            Ответственность за правомерность предоставления и
                            достоверность Персональных данных Пользователя и
                            иных лиц, данные которых сообщены, несёт
                            исключительно Пользователь.
                        </p>
                        <p>
                            6.8. Администратор не несёт ответственности за
                            утрату, подмену или порчу данных, а также за иные
                            последствия, наступившие в результате невыполнения
                            Пользователем условий, предусмотренных настоящим
                            Соглашением.
                        </p>
                        <p>
                            6.9. Администратор не несёт ответственности за
                            организацию использования протоколов OpenID и OAuth
                            третьими лицами и надлежащее обеспечение ими защиты
                            информации о Пользователях, а также получение
                            законного предварительного согласия Пользователей на
                            обработку Администратором их Персональных данных в
                            рамках использования указанных протоколов.
                        </p>
                    </div>
                </div>
                <div className="flex flex-col w-full items-start justify-start">
                    <div className="flex flex-row w-full items-center justify-center font-semibold">
                        7. ИСПОЛЬЗОВАНИЕ ИНФОРМАЦИИ, ХРАНЯЩЕЙСЯ НА СТОРОНЕ
                        БРАУЗЕРА
                    </div>
                    <div className="flex flex-col w-full items-start justify-stretch indent-7 text-justify">
                        <p>
                            7.1. Администратор использует информацию, хранящуюся
                            на стороне браузера Пользователя, для определения
                            уникального идентификатора доступа Пользователя к
                            Сайту с целью:
                        </p>
                        <p>
                            7.1.1. поддержки функциональности ресурсов,
                            требующих использования информации, хранящейся на
                            стороне браузера;
                        </p>
                        <p>7.1.2. измерения размеров аудитории Сайта;</p>
                        <p>
                            7.1.3. определения статистических информационных
                            предпочтений Пользователей при доступе к различным
                            страницам Сайта;
                        </p>
                        <p>
                            7.1.4. определения в исследовательских целях
                            корреляции статистических данных о посещаемости
                            Сайта с социометрическими данными о Пользователях.
                        </p>
                        <p>
                            7.2. Путём настройки программного обеспечения
                            Пользователь имеет возможность запретить
                            использование информации, хранящейся на стороне
                            браузера, на своём компьютере, однако это может
                            привести к частичной или полной потере
                            функциональности страниц Сайта.
                        </p>
                    </div>
                </div>
                <div className="flex flex-col w-full items-start justify-start">
                    <div className="flex flex-row w-full items-center justify-center font-semibold">
                        8. СОГЛАСИЕ НА ОБРАБОТКУ ПЕРСОНАЛЬНЫХ ДАННЫХ
                    </div>
                    <div className="flex flex-col w-full items-start justify-stretch indent-7 text-justify">
                        <p>
                            8.1. Заключая настоящее Соглашение, Пользователь
                            принимает условия Политики конфиденциальности ООО
                            «Технологии закупок», размещенной по адресу
                            https://noxsys.ru/#/docs/user-agreement
                        </p>
                    </div>
                </div>
                <div className="flex flex-col w-full items-start justify-start">
                    <div className="flex flex-row w-full items-center justify-center font-semibold">
                        9. ИЗМЕНЕНИЕ УСЛОВИЙ И РАСТОРЖЕНИЕ СОГЛАШЕНИЯ
                    </div>
                    <div className="flex flex-col w-full items-start justify-stretch indent-7 text-justify">
                        <p>
                            9.1. Переходя по ссылке https://noxsys.ru
                            Пользователь подтверждает, что принимает условия
                            настоящего Соглашения, а также Политики
                            конфиденциальности Сайта, являющейся неотъемлемой
                            частью настоящего Соглашения, размещенной на
                            странице по адресу
                            https://noxsys.ru/#/docs/user-agreement
                        </p>
                        <p>
                            9.2. Пользователь соглашается, что настоящее
                            Соглашение может быть изменено Администратором в
                            одностороннем порядке путём размещения обновлённого
                            текста Соглашения в сети Интернет. Пользователь
                            подтверждает своё согласие с изменениями условий
                            Соглашения путём использования Сайта. При несогласии
                            с изменённой версией Соглашения Пользователь
                            обязуется прекратить использование Сайта.
                        </p>
                    </div>
                </div>
                <div className="flex flex-col w-full items-start justify-start">
                    <div className="flex flex-row w-full items-center justify-center font-semibold">
                        10. ИНФОРМАЦИЯ ОБ АДМИНИСТРАТОРЕ
                    </div>
                    <div className="flex flex-col w-full items-start justify-stretch indent-7 text-justify">
                        <p>Наименование: ООО «Технологии Закупок»</p>
                        <p>ОРГН 1211400010491</p>
                        <p>ИНН 1435363820</p>
                        <p>
                            Юридический адрес: 677000, Российская Федерация,
                            Республика Саха (Якутия), г. Якутск, пр. Ленина, 1,
                            офис 625
                        </p>
                        <p>Телефон: 8-914-223-44-01</p>
                        <p>Адрес электронной почты: info@noxsys.ru</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UserAgreementPage
